import { encryptPDF } from '@pdfsmaller/pdf-encrypt';
import { PDFDocument } from 'pdf-lib';

export async function tryNormalizePdfBytes(bytes) {
    const pdf = await PDFDocument.load(bytes, { ignoreEncryption: true });
    const saved = await pdf.save({ useObjectStreams: false });
    return new Uint8Array(saved);
}

/**
 * Try AES-256 and RC4 encryption, with and without pdf-lib normalization.
 * @param {Uint8Array} bytes
 * @param {string} userPassword
 * @param {object} options - passed to encryptPDF (without algorithm)
 */
export async function encryptPdfWithFallbacks(bytes, userPassword, options) {
    const algorithms = ['AES-256', 'RC4'];
    const strategies = [];

    for (const algorithm of algorithms) {
        const opts = { ...options, algorithm };
        strategies.push(() => encryptPDF(bytes, userPassword, opts));
        strategies.push(async () => {
            const normalized = await tryNormalizePdfBytes(bytes);
            return encryptPDF(normalized, userPassword, opts);
        });
    }

    let lastError;
    for (const run of strategies) {
        try {
            return await run();
        } catch (err) {
            lastError = err;
        }
    }
    throw lastError;
}
